import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext } from "./../appContext";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CardHeader from '@material-ui/core/CardHeader';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';




const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  field: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "55ch",
    },
  },
  addUpdateBtn: {
    marginTop:10
  },
  cancelbtn:{
    marginTop:10,
    marginLeft:10
  }
}));

const useCardStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginTop:12,
    marginBottom: 3,
  },
});



export default function Language() {
  const classes = useStyles();

  let [resume, setResume] = useContext(AppContext);

  let [addForm, setAddForm] = useState({
    name: "",
    details:""
  });

  let [isNew, setIsNew] = useState(true);
  let [updateIndexNo, setUpdateIndexNo] = useState(0);

  // console.log("resume on Language page", resume);

  const handleChange = (event) =>{
    event.preventDefault();
    event.stopPropagation();
    // this.setState({defaultValue: event.target.defaultValue});
    // console.log(event.target.value)
    // console.log(event.target.id);
    let formDetail = {...addForm, [event.target.id]:event.target.value}
    setAddForm(formDetail);
  };

  const handleAdd = (event) =>{
    event.preventDefault();
    event.stopPropagation();
    // console.log(addForm);
    var existingLanguages = resume.languages;

    // Check if form is empty | return

    if(addForm.name == '' ){
      alert('Validation Failed');
      return;
    }

    // Check if New Form or Update
    if(isNew){ //New
      existingLanguages.unshift(addForm);
    }
    else{ //Existing
      existingLanguages[updateIndexNo] = addForm;
    }

    // console.log(updateIndexNo, existingLanguages);
    
    
    setResume({...resume, ["languages"]:existingLanguages})

    // console.log(resume);
    resetForm();
  }

  const handeleCancel = (event) => {
    event.preventDefault();
    event.stopPropagation();

    resetForm();

  }

  const onEdit =(index) => {
    // console.log(index);
    setUpdateIndexNo(index);
    setIsNew(false);
    let exisitingLanguages = resume.languages[index];
    setAddForm(exisitingLanguages);
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };

  const onDelete = (index) => {
    resetForm();
    let exisitingLanguages = resume.languages;
    exisitingLanguages.splice(index,1);
  }

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    // console.log(result);

    const items = reorder(
      resume.languages,
      result.source.index,
      result.destination.index
    );

    // console.log('final',items);
    setResume({...resume, ["languages"]:items})

    //reset form as well
    resetForm();
  };
  
  const resetForm = () =>{
    setIsNew(true);
    setAddForm({
        name: "",
        details:"",
    });
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="draggable-1">
            {(provided, snapshot) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {resume.languages.map((e,index)=>
                  <Draggable draggableId={`d-${index}`} key={index} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <LanguageDisplayCard data={e} key={index} edit={onEdit} cardIndex={index} delete={onDelete}></LanguageDisplayCard>
                      </div>
                    )}
                  </Draggable>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          </DragDropContext>
        
         
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h5" >{isNew ? 'Add New Language': 'Update Language'}</Typography>
          <form className={classes.field} onChange={handleChange} noValidate autoComplete="off" onSubmit={handleAdd}>
            <TextField required id="name" onChange={handleChange} label="Name" value={addForm.name} />
            
            <br />
            <Button type="submit" onClick={handleAdd} className={classes.addUpdateBtn} variant="contained">{isNew ? 'Add' : 'Update'}</Button>
            {!isNew && 
             <Button onClick={handeleCancel} className={classes.cancelbtn} variant="contained">Cancel</Button>
            }
          </form>
        </Grid>
       
      </Grid>
    </div>
  );
}



function LanguageDisplayCard(props){
  let data = props.data;
  // console.log(props)
  const cardClasses = useCardStyles();
  return(
    <React.Fragment>
      <Card className={cardClasses.root}>
        <CardHeader
          action={
            <React.Fragment>
              <IconButton aria-label="edit" onClick={(e)=>{props.edit(props.cardIndex)}}>
                <EditIcon />
              </IconButton>
              <IconButton aria-label="edit" onClick={(e)=>{props.delete(props.cardIndex)}}>
                <DeleteOutlineIcon />
              </IconButton>
            </React.Fragment>
          }
          title={data.name}
        //   subheader={data.period}
        />
        {/* <CardContent>
          <Typography className={cardClasses.title} color="textSecondary" gutterBottom>
            {data.university}
          </Typography>
         
        </CardContent> */}
    
      </Card>
      <br></br>
    </React.Fragment>
  )
}